export default function Multiple_Regression() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Multiple_Regression</h1>
      <p>Content for Multiple_Regression goes here.</p>
    </div>
  );
}